import React, { useCallback, useEffect, useState } from 'react'
import { Assessment, assessmentDefsHooks } from 'pages/AssessmentDefs'
import { WrapAssessmentDefsItems, WrapHeaderActions, } from './Style'
import { fieldsTyps, Input } from 'components/Form'
import { searchByKeys } from 'utils/array'
import { SmallSpace, WrapAll, WrapHeader } from 'styles/GlobalStyle'
import { isEmpty } from 'lodash'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getAssessmentDefsFetch } from 'store/middlewares/assessment.crud'
import { assessmentsHooks } from '../School/Assessments'
import { WrapDataGrid } from 'components/DataGrid/Style'
import { actions } from 'store'
import { useDispatch } from 'react-redux'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'

const AssessmentDefs = (props) => {
    const { headerFilters, setSelectedAssessmentDefs, shouldUseParentData, showBattery, hideFilters, assessments, assessmentFilters: pAssessmentFilters, setAssessmentFilters: pSetAssessmentFilters } = props
    const [filterAssessments, setFilterAssessments] = useState(assessments?.data)
    const [assessmentFilters, setAssessmentFilters] = useState({
        category: null,
        battery: null
    })
    const dispatch = useDispatch()

    const headerItems = assessmentsHooks.useHeaderItems()

    const currentAssessmentFilters = pAssessmentFilters || assessmentFilters

    const assessmentDefOptions = useQuery({
        queryKey: [qc.allAssessmentDefs, pAssessmentFilters],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentDefsFetch({ headerFilters: headerFilters, assessmentFilters: currentAssessmentFilters }, signal)
            setFilterAssessments(data)
            if (currentAssessmentFilters.battery) {
                // אם מגיע מקומפוננטת האב פונקציית השמה למבדקים שנבחרו
                if (setSelectedAssessmentDefs) setSelectedAssessmentDefs(data)
                // אם לא תשמור בחנות הגלובלית
                else dispatch(actions.setSelectedAssessmentDefs(data))
            }
            return data
        },
        initialData: assessments,
        enabled: !shouldUseParentData,
    })

    const [searchVal, setSearchVal] = useState('')

    const headerActions = assessmentDefsHooks.useHeaderActions()
    const { search, assessmentKeysForSearch } = assessmentDefsHooks.constants

    // const currentAssessments = assessments || assessmentDefOptions.data || []

    useEffect(() => {
        if (assessments?.data)
            setFilterAssessments(assessments?.data)
    }, [assessments?.data])

    const searchAssessmentDefs = (val) => {
        setSearchVal(val)
        const nAssessmentDefs = searchByKeys(assessments?.data || assessmentDefOptions.data, val, assessmentKeysForSearch)
        setFilterAssessments(nAssessmentDefs)
    }

    const refetchData = useCallback(() => {
        if (assessments?.refetch)
            assessments.refetch()
        else
            assessmentDefOptions?.refetch()
    }, [assessments])

    let filters = [
        { ...headerItems.category, multiple: false }
    ]
    if (showBattery)
        filters.push(headerItems.battery)

    return (
        <WrapDataGrid overflow>
            {hideFilters ||
                <AssessmentFiltersHeader
                    keys={['category']}
                    refetchData={refetchData}
                    headerItems={filters}
                    assessmentFilters={currentAssessmentFilters}
                    setAssessmentFilters={(values) => pSetAssessmentFilters ? pSetAssessmentFilters(values) : setAssessmentFilters(values)}
                />}
            <WrapAll>
                <WrapHeader height={50}>
                    <WrapHeaderActions>
                        <Input {...search}
                            input={{
                                value: searchVal,
                                onChange: searchAssessmentDefs
                            }} />
                        {headerActions.map((act, index) => {
                            const Component = fieldsTyps[act.component]
                            return (
                                <Component key={index} {...act} />)
                        })}
                    </WrapHeaderActions>
                </WrapHeader>
                <SmallSpace />
                <WrapAssessmentDefsItems>
                    {isEmpty(filterAssessments) || filterAssessments?.map((assessment) =>
                        <Assessment
                            student={true}
                            key={assessment.id}
                            {...props}
                            {...assessment} />
                    )}
                </WrapAssessmentDefsItems>
            </WrapAll>
        </WrapDataGrid>
    )
}

export default AssessmentDefs